import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-vault-statistics',
  templateUrl: './vault-statistics.component.html',
  styleUrls: ['./vault-statistics.component.scss']
})
export class VaultStatisticsComponent implements OnInit {

  @Input() public baseUrl: string = null;
  private poller: Subscription = null;
  public summary: VaultSummary = { available: 0, totalValue: 0, awardedToday: 0, importedToday: 0 };

  constructor(private readonly api: ApiService) { }

  public ngOnInit() {
    console.log(this.baseUrl);
    this.poller = interval(3000)
      .subscribe(i => {
        this.refresh();
      });

    this.refresh();
  }

  private refresh(): void {

    if (!this.baseUrl) {
      return;
    }
    this.api.list(this.baseUrl).subscribe((data: VaultSummary) => {
      this.summary = data;
      this.poller.unsubscribe();
    });
  }

}

interface VaultSummary {
  available?: number;
  testCodes?: number;
  totalValue?: number;
  awardedToday?: number;
  importedToday?: number;
}
